import { Observable } from "rxjs";
import { Process } from "@planard/@core/entities/process";

export abstract class ProcessData {
  abstract listAll(): Observable<Process[]>;
}
